export class Group {
    constructor(options) {
        this.organisation_id = options.organisation_id;
        this.title = options.title || 'New Group';
        this.default = options.default || false;
        this.deleted = false;
    }
}
export var GroupRuleType;
(function (GroupRuleType) {
    GroupRuleType["EXTERNAL_AGGREGATE"] = "EXTERNAL_AGGREGATE";
})(GroupRuleType || (GroupRuleType = {}));
export class IGroup {
}
//# sourceMappingURL=group.js.map